import { useRouter, useContext } from '@nuxtjs/composition-api';
import type { Product } from '~/modules/catalog/product/types';
import useCart from '~/modules/checkout/composables/useCart';
import { useProduct } from '~/modules/catalog/product/composables/useProduct';
import { useUiNotification, useUiState } from '~/composables';

export const useAddToCart = () => {
  const {
    addItem: addItemToCartBase,
    isInCart,
  } = useCart();
  const { send: sendNotification } = useUiNotification();
  const router = useRouter();
  const { app } = useContext();
  const { getProductPath } = useProduct();
  const { showCartSidebar } = useUiState();
  const addItemToCart = async (params: { product: Product, quantity: number }) => {
    const { product, quantity } = params;
    // @ts-ignore
    // eslint-disable-next-line no-underscore-dangle
    const productType = product.__typename;

    switch (productType) {
      case 'SimpleProduct':
        await addItemToCartBase({
          product,
          quantity,
        });
        sendAddedToCartNotification(product);
        showCartSidebar();
        break;
      case 'BundleProduct':
      case 'ConfigurableProduct':
      case 'GroupedProduct':
        const path = app.localeRoute(getProductPath(product));

        await router.push(path);
        break;
      default:
        throw new Error(`Product Type ${productType} not supported in add to cart yet`);
    }
  };

  function sendAddedToCartNotification(product: Product) {
    sendNotification({
      id: Symbol('product_added_to_cart_from_wishlist'),
      message: app.i18n.t(
        'Added to your cart.',
        { product: product.name },
      ) as string,
      type: 'success',
      icon: 'check',
      persist: false,
      title: 'Cart',
    });
  }
  return {
    showCartSidebar,
    addItemToCart,
    isInCart,
  };
};
